import OptionalInput from "./FieldOptionalInput";
import { withErrorMessage } from "../withErrorMessage";

export const FieldOptionalInput = withErrorMessage(OptionalInput);

export default FieldOptionalInput;
